import { render } from "./CreateWhitelabel.vue?vue&type=template&id=4a5886a9&scoped=true"
import script from "./CreateWhitelabel.vue?vue&type=script&lang=js"
export * from "./CreateWhitelabel.vue?vue&type=script&lang=js"

import "./CreateWhitelabel.vue?vue&type=style&index=0&id=4a5886a9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a5886a9"]])

export default __exports__